import React from 'react';
import Modal from './Modal';

/**
 * Modernized PrimaryModal preserving exact prop signature for 100% backward compatibility.
 */
const PrimaryModal = ({
  children,
  title,
  subtitle,
  hideModal,
  onClose,
  widthClass = '',
  loading = false,
  zIndex = 999,
  ariaLabel,
}) => {
  return (
    <Modal
      isOpen={true}
      title={title}
      subtitle={subtitle}
      onClose={hideModal || onClose}
      widthClass={widthClass}
      loading={loading}
      zIndex={zIndex}
      ariaLabel={ariaLabel}
    >
      {children}
    </Modal>
  );
};

export default PrimaryModal;
